var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"industry-root py-16"},[_c('FormattedHeader',{staticClass:"max-w-xl mx-auto mb-16 px-4",attrs:{"header":_vm.header,"subheader":_vm.subheader}}),_vm._v(" "),_c('IndustryGrid',{staticClass:"mb-20"})],1)}
var staticRenderFns = []

export { render, staticRenderFns }